import { render, staticRenderFns } from "./UserGroupUsersTable.vue?vue&type=template&id=c9972e3c&"
import script from "./UserGroupUsersTable.vue?vue&type=script&lang=js&"
export * from "./UserGroupUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports